import * as signalR from "@microsoft/signalr";
import eventBus from "@/lib/eventBus";

let connection = null; // 👈 Hold the connection instance
const CONNECTION_STOP_TIMEOUT_MS = 2000;
const intentionalStops = new WeakSet();

export const startSignalR = async ({
  tokenFactory,
  onForceLogout,
  onUpdateUserInfo,
  onTranslationUpdate,
  onConfigurationUpdate,
  onConnectionClosed,
  onReconnected,
  onNotificationCreated,
  onNotificationsChanged,
}) => {
  if (connection) {
    if (connection.state === signalR.HubConnectionState.Disconnected) {
      await connection.start();
    }
    return;
  }

  const nextConnection = new signalR.HubConnectionBuilder()
    // .withUrl("https://localhost:7257/hubs/presence", {
    .withUrl("/hubs/presence", {
      accessTokenFactory: async () => {
        const token = await tokenFactory();
        return token;
      },
    })
    .withAutomaticReconnect()
    .configureLogging(signalR.LogLevel.Warning)
    .build();

  connection = nextConnection;

  nextConnection.on("UserStatusChanged", (payload) => {
    console.log("UserStatusChanged", payload);
    eventBus.emit("UserStatusChanged", payload);
  });

  nextConnection.on("ForceLogout", () => {
    console.warn("❗ ForceLogout received from server");
    eventBus.emit("ForceLogout");
    onForceLogout?.();
  });

  nextConnection.on("UpdateUserInfo", async () => {
    eventBus.emit("UpdateUserInfo");
    if (onUpdateUserInfo) await onUpdateUserInfo();
  });

  nextConnection.on("TranslationUpdated", async () => {
    eventBus.emit("TranslationUpdated");
    if (onTranslationUpdate) await onTranslationUpdate();
  });

  nextConnection.on("ConfigurationUpdated", async () => {
    if (onConfigurationUpdate) await onConfigurationUpdate();
    eventBus.emit("ConfigurationUpdated");
  });

  nextConnection.on("NotificationCreated", async (notification) => {
    eventBus.emit("NotificationCreated", notification);
    if (onNotificationCreated) await onNotificationCreated(notification);
  });

  nextConnection.on("NotificationsChanged", async (summary) => {
    eventBus.emit("NotificationsChanged", summary);
    if (onNotificationsChanged) await onNotificationsChanged(summary);
  });

  nextConnection.onreconnected(async () => {
    if (onReconnected) await onReconnected();
  });

  nextConnection.onclose(() => {
    if (intentionalStops.has(nextConnection)) return;

    if (connection === nextConnection) {
      connection = null;
    }

    onConnectionClosed?.();
  });

  try {
    await nextConnection.start();
  } catch (error) {
    if (connection === nextConnection) {
      connection = null;
    }
    throw error;
  }
};

export const clearConnection = async () => {
  const currentConnection = connection;
  connection = null;

  if (currentConnection) {
    try {
      intentionalStops.add(currentConnection);
      await Promise.race([
        currentConnection.stop(),
        new Promise((resolve) =>
          setTimeout(resolve, CONNECTION_STOP_TIMEOUT_MS),
        ),
      ]);
    } catch {}
  }
};
